var lib_core = require("lib-core");
var lib_geometry = require("lib-geometry");
var editor_2d = require("editor-2d");

var SymbolGeneratorHandleModel = function (interactionModel) {
    var self = this;
    this.makeObservableTreeNode();

    this.interactionModel = interactionModel;
    this.modelData = interactionModel.data;

    this.pos = this.value("pos", true);
    this.selected = this.value("selected", true);
    this.highlighted = this.value("highlighted", true);
    this.activeFlag = this.value("activeFlag", true);

    this.centerMode = false;
    this.shiftMode = false;
    this.anchor = false;
    this.dir = new lib_geometry.Coord(1,-1);
    // whoever did this ^ I love you

    self.selectionModel = null;
    if(self.interactionModel && self.interactionModel.editorModel && self.interactionModel.editorModel.selectionModel) {
        self.selectionModel = self.interactionModel.editorModel.selectionModel();
    }

    this.noUpdateModel = false;
    this.noUpdateHandle = false;

    this.updateHandle();

    this.selected.onChange("selected_infocus", function(value) {
        if(self.isAlive() && self.interactionModel.isAlive())
            self.interactionModel.infocus(value);
    }, 10);
    this.pos.onChange("interaction_model_coupling", function(){
        if (null == self.pos()) return;
        if(!self.noUpdateModel) {
            self.updateModel();
        }
    });
    // this.dir.onChange("interaction_model_coupling_reverse", function () {
    //     if(self.isAlive() && self.interactionModel.isAlive() && self.interactionModel.selected()) {
    //         self.noUpdateModel = true;
    //         self.updateHandle(!self.noUpdateHandle);
    //         self.noUpdateModel = false;
    //     }
    // }, 10);

    this.modelData.width.onChange("interaction_model_coupling_reverse", function () {
        if(self.isAlive() && self.interactionModel.isAlive() && self.interactionModel.selected()) {
            self.noUpdateModel = true;
            self.updateHandle(!self.noUpdateHandle);
            self.noUpdateModel = false;
        }
    }, 10);
    this.modelData.height.onChange("interaction_model_coupling_reverse", function () {
        if(self.isAlive() && self.interactionModel.isAlive() && self.interactionModel.selected()) {
            self.noUpdateModel = true;
            self.updateHandle(!self.noUpdateHandle);
            self.noUpdateModel = false;
        }
    }, 10);
    this.modelData.pos.onChange("interaction_model_coupling_reverse", function () {
        if(self.isAlive() && self.interactionModel.isAlive() && self.interactionModel.selected()) {
            self.noUpdateModel = true;
            self.updateHandle(!self.noUpdateHandle);
            self.noUpdateModel = false;
        }
    }, 10);
    this.modelData.angle.onChange("interaction_model_coupling_reverse", function () {
        if(self.isAlive() && self.interactionModel.isAlive() && self.interactionModel.selected()) {
            self.noUpdateModel = true;
            self.updateHandle(!self.noUpdateHandle);
            self.noUpdateModel = false;
        }
    }, 10);


};
lib_core.mixin(SymbolGeneratorHandleModel, lib_core.ObservableTreeNode);
lib_core.JsonParser.registerClass(SymbolGeneratorHandleModel, "SymbolGeneratorHandleModel");

module.exports = SymbolGeneratorHandleModel;

SymbolGeneratorHandleModel.prototype.updateModel = function () {
    var self = this;

    this.noUpdateHandle = true;

    var vec = null;

    if (this.centerMode) {
        this.anchor = this.modelData.pos().mult(2).sub(this.pos());

        vec = this.pos().sub(this.modelData.pos()).rotate(-this.modelData.angle());
        this.modelData.width(2 * Math.abs(vec.getX()));
        this.modelData.height(2 * Math.abs(vec.getY()));
    } else {
        var newPos = this.anchor.add(this.pos()).mult(1/2);

        vec = this.pos().sub(newPos).rotate(-this.modelData.angle());

        this.modelData.width(2 * Math.abs(vec.getX()));
        this.modelData.height(2 * Math.abs(vec.getY()));
        this.modelData.pos(newPos);
    }

    var xDir = vec.getX() > 0 ?  1 :
        vec.getX() < 0 ? -1 :
        this.dir.getX();
    var yDir = vec.getY() > 0 ?  1 :
        vec.getY() < 0 ? -1 :
        this.dir.getY();

    if(!(this.centerMode && this.shiftMode)) this.dir = new lib_geometry.Coord(xDir, yDir);

    this.noUpdateHandle = false;
};

SymbolGeneratorHandleModel.prototype.getSnapSet = function () {
    var snapSet = new editor_2d.SnapSet();

    snapSet.addHor(this.pos(), 1);
    snapSet.addVer(this.pos(), 1);

    return snapSet;
};

SymbolGeneratorHandleModel.prototype.move = function (vec, keys) {
    // if this is being moved, after being drawn, then absVec will have been set
    // via onElementMovingStart ... this adjustment makes sure the vector is correct with
    // respect to the current pos position ... (due to rounding/other errors the handle
    // and mouse position may not be equal without this adjustment - take my word for it)
    if(this.absVec) {
        this.absVec = this.absVec.add(vec);

        // where do we want it?
        var target = this.origCoord.add(this.absVec);

        // what should the vector be?
        vec = target.sub(this.pos());
    } else {
        // if this is being drawn for the first time, set the pos and absvec
        this.origCoord = this.pos();
        this.absVec = new lib_geometry.Coord(0,0);
    }

    this.centerMode = keys.altKey;
    this.shiftMode =keys.shiftKey;

    var enforceMinSize = false;

    var newCoord = this.pos().add(vec);
    var sizeVec = newCoord.sub(this.anchor).rotate(-this.modelData.angle());

    var width = sizeVec.getX();
    if(width < this.modelData.getMinBoxWidth()) {
        sizeVec.x = this.modelData.getMinBoxWidth();
        enforceMinSize = true;
    }

    var height = Math.abs(sizeVec.getY());
    if(height < this.modelData.getMinBoxHeight()) {
        sizeVec.y = this.modelData.getMinBoxHeight() * this.dir.getY();
        enforceMinSize = true;
    }

    newCoord = this.anchor.add(sizeVec.rotate(this.modelData.angle()));

    this.pos(newCoord);

    if(enforceMinSize) {
        this.updateHandle();
    }
};

SymbolGeneratorHandleModel.prototype.onElementMovingStart = function() {
    this.origCoord = this.pos();
    this.absVec = new lib_geometry.Coord(0,0);
};


SymbolGeneratorHandleModel.prototype.doubleClickAction = function () {
};

SymbolGeneratorHandleModel.prototype.updateHandle = function(update) {
    var self = this;

    if (update == undefined) update = true;

    if (update) {
        var width = this.modelData.width();
        var height = this.modelData.height();
        var center = this.modelData.pos();
        var angle = this.modelData.angle();

        var center_to_handle = new lib_geometry.Coord(width/2, height/2)
            .mult(self.dir.getX(), self.dir.getY())
            .rotate(angle);
        var newCoord = center.add(center_to_handle);
        var newAnchor = center.sub(center_to_handle);

        if (!(this.pos() && newCoord.eq(this.pos()))) {
            this.pos(newCoord);
        }
        if (!(this.anchor && newAnchor.eq(this.anchor))) {
            this.anchor = newAnchor;
        }
    }
};

SymbolGeneratorHandleModel.prototype.setSelected = function (selected) {
    this.selected(selected);
};

SymbolGeneratorHandleModel.prototype.getInspectorElements = function () {
    return this.parent().getInspectorElements();
};

